// extracted by mini-css-extract-plugin
export default {"footerContainer":"pxWTS6qE","footerContacts":"NT0XtP5U","footerIcon":"JmFtfYg3"};